import React, { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router';
import SignUpSplash from './components/media-kit/SignUpSplash';
//import MediaKit from './MediaKit';
import RoutingTest from './RoutingTest';

class App extends Component {

  render() {
    return (
      <Switch>
                <Route exact path='/' component={SignUpSplash} /> 
                <Route exact path='/RoutingTest' component={RoutingTest} />                              
      </Switch>
    );
  }
}

export default App;